import * as React from "react";
import mark from "../../../../assets/images/speak-no-monkey.png"
import BubbleChart from "../../chart/BubbleChart";
import noGuidanceNanu from '../../../../assets/images/no_guide_nanu.png'
import noGuidanceBadge from '../../../../assets/images/Party popper.png'
import {useEffect} from "react";
import allCompleteNanu from "../../../../assets/images/all_complete_nanu.png";

const filterNames = {
    LOW_ACCURACY: "정확도 미흡",
    LOW_SPEED: "속도 미흡",
    GUESSING_SUSPECTED: "찍기 의심",
};

const filterTextColors = {
    LOW_ACCURACY: "#61a50d", // 정확도 부족 색상
    LOW_SPEED: "#b959ea",    // 속도 미달 색상
    GUESSING_SUSPECTED: "#597dea", // 찍기 의심 색상
};

const filterCircleColors = {
    LOW_ACCURACY: "#e5f9c7", // 정확도 부족 색상
    LOW_SPEED: "#f6e5ff",    // 속도 미달 색상
    GUESSING_SUSPECTED: "#e5efff", // 찍기 의심 색상
};

const selectedFilters = ["LOW_ACCURACY", "LOW_SPEED", "GUESSING_SUSPECTED"];

const NeedsGuidance = ({filterInfoList}) =>{


    const guidanceNeeded = filterInfoList.find(
        (filter) => filter.filterType === "NEEDS_GUIDANCE"
    );

    const guidanceCount = guidanceNeeded ? guidanceNeeded.studentList.length : 0;

    const chartData = filterInfoList
        .filter((filter) => selectedFilters.includes(filter.filterType)) // 필요한 필터만 추출
        .map((filter) => {
            return {
                name: filterNames[filter.filterType], // 필터 이름 매핑
                value: filter.studentList.length, // 학생 수
                color: filterTextColors[filter.filterType], // 필터별 색상 매핑
                circleColor: filterCircleColors[filter.filterType],
            };
        });

    return guidanceCount>0 ? (
            <div
                className="flex flex-col px-5 pt-6 pb-3 h-full mx-auto w-full bg-white  text-xl font-black rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] max-md:pr-5 max-md:mt-5">
                <div className="flex gap-2 self-start text-base text-zinc-600 max-md:ml-1 w-full">
                    <img
                        loading="lazy"
                        src={mark}
                        alt="Guidance needed icon"
                        className="object-contain shrink-0 w-8 aspect-square"
                    />
                    <div className="flex gap-1.5 justify-center items-center my-auto w-full">
                        <div className="my-auto text-base basis-auto text-left font-black">
                            앗! 지도가 필요해요.
                        </div>
                        <div
                            className="flex flex-col self-stretch my-auto w-12 text-sm font-semibold text-center text-rose-500 whitespace-nowrap rounded-[100px] ml-auto">
                            <div className="gap-2 self-stretch px-2 py-1 bg-rose-200 min-h-[22px] rounded-[100px]">
                                {guidanceCount}명
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ml-11 text-sm font-medium text-neutral-400 text-left ">
                    항목별로 지도가 필요한 학생이
                    <br/>몇 명인지 알 수 있어요.
                </div>
                <BubbleChart chartData={chartData} guidanceCount={guidanceCount}></BubbleChart>

            </div>
        ) : (
            <div
                className="flex flex-col px-5 pt-6 pb-3 h-full mx-auto w-full bg-white  text-xl font-black rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] max-md:pr-5 max-md:mt-5">
                <div className="flex gap-2 self-start text-base text-zinc-600 max-md:ml-1 w-full">
                    <img
                        loading="lazy"
                        src={noGuidanceBadge}
                        alt="Guidance needed icon"
                        className="object-contain shrink-0 w-8 aspect-square"
                    />
                    <div className="flex gap-1.5 justify-center items-center my-auto w-full">
                        <div className="my-auto text-base basis-auto text-left font-black">
                            지도가 필요한 학생이 없어요!
                        </div>
                        <div
                            className="flex flex-col self-stretch my-auto w-12 text-sm font-semibold text-center text-blue-500 whitespace-nowrap rounded-[100px] ml-auto">
                            <div className="gap-2 self-stretch px-2 py-1 bg-[#D7E5FE] min-h-[22px] rounded-[100px]">
                                {guidanceCount}명
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ml-11 text-sm font-medium text-neutral-400 text-left ">
                    학생들을 칭찬해 주세요.
                </div>
                <div className="flex items-end justify-center h-[300px]" // 스크롤 활성화 및 최대 높이 설정
                >
                    <img
                        loading="lazy"
                        src={noGuidanceNanu}
                        alt="all complete nanu"
                        className="w-[210px] h-[201px] mb-3"
                    />
                </div>
            </div>
        );
}

export default NeedsGuidance;